import { DropdownButton } from "./DropdownButton";
import { HeaderStyled, TopBarContainer } from "./HeaderStyled";

function Header() {
  return (
    <HeaderStyled>
      <TopBarContainer className="top-bar-container">
        <div className="top-bar-left">
          {/* <img src={images.logoForm} alt="logo" /> */}
          <h1>VAMS 資産棚卸管理システム</h1>
        </div>
        <div className="top-bar-right">
          <DropdownButton />
        </div>
      </TopBarContainer>
    </HeaderStyled>
  );
}

export { Header };
